import { useRef, useCallback } from 'react';
import { useFormikContext } from 'formik';

export const useFocusOnError = () => {
  const { validateForm } = useFormikContext();
  const fieldRefs = useRef<Record<string, HTMLInputElement | null>>({});

  const registerField = useCallback(
    (fieldName: string) => (element: HTMLInputElement | null) => {
      fieldRefs.current[fieldName] = element;
    },
    []
  );

  const focusElement = useCallback((fieldName: string) => {
    const element = fieldRefs.current[fieldName];
    if (element) {
      element.focus();
      return true;
    }
    return false;
  }, []);

  const focusRegularField = useCallback(
    (fieldName: string, errors: any) => {
      if (errors[fieldName]) {
        return focusElement(fieldName);
      }
      return false;
    },
    [focusElement]
  );

  const focusOnFirstError = useCallback(async () => {
    const errors = await validateForm();
    const fieldPriority = ['name', 'email'] as const;

    for (const fieldName of fieldPriority) {
      if (focusRegularField(fieldName, errors)) {
        break;
      }
    }
  }, [focusRegularField, validateForm]);

  return {
    registerField,
    focusOnFirstError,
  };
};
